interface ScreenHeaderProps {
  title: string;
  onBack: () => void;
}

export default function ScreenHeader({ title, onBack }: ScreenHeaderProps) {
  return (
    <div className="flex items-center justify-between px-5 pt-3 pb-4 shrink-0">
      <button
        type="button"
        aria-label="Back"
        onClick={onBack}
        className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-foreground-950 cursor-pointer transition-colors hover:bg-secondary-200 active:bg-secondary-300"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <h1 className="text-lg font-bold text-foreground-950 font-heading">
        {title}
      </h1>
      <div className="w-10 h-10" aria-hidden="true" />
    </div>
  );
}